import { ChargingPower } from "@models/chargingPower";
import { ConnectorSystems } from "@models/connectorSystems";
import { Manufacturer } from "@models/manufacturer";
import { Pricing } from "@models/pricing";
import { Customer } from "@models/customer";
import { ChargingStationDlm } from "@models/ChargingStationDlm"
import { Model } from "@models/model";
import { Profile } from "@models/profile";
import { ChargingPoint } from "@models/chargingPoint";
import { Address } from "../models/address";
import { ChargingStationStatus } from "@models/chargingStationStatus";

export class ChargingStationTableDto {
  id: string;
  name: string;
  //location: string;
  //lat : string;
  //lon: string;
  //address: Address;
  //addressId: number;
  manufacturer: Manufacturer;
  manufacturerId: number;
  model: Model;
  modelId: number;
  profileId: number;
  profile: Profile;
  //serialNumber: string;
  //chargePointSerialNumber: string;
  installationDate: Date;
  //connectorSystems: ConnectorSystems;
  //connectorSystemsId: number;
  //chargingPowerId: number;
  //chargingPower: ChargingPower;
  //chargingPowerName: string;
  //cableLength: string;
  isFreeCharge: boolean;
  isPublicCharge: boolean;
  isPrivateCharge: boolean;
  //firmware: string;
  //isScanModeActive: boolean;
  //pricings: Pricing[];
  /**
   * concatenated status of all charging points (used for sorting)
   */
  chargingPointsStatus: string;

  // charging station status -> connector id 0. also see charging point status.
  statusId: number;
  status: ChargingStationStatus;

  chargingPoints: ChargingPoint[];
  //dlmMapping: any;
  customerId: number;
  customer: Customer;
  //chargingStationDlmId: number;
  //chargingStationDlm: ChargingStationDlm;
  //localIP: string;
  //key: string;
  offlineSince: Date;
  isHubjectAvailable: boolean;
  isHubjectCompatible: boolean;
  displayChargeMode: string;
  offlineStatusReported: boolean;
  displayOffLineReported: string;
  connectorCount?: number;
  csId?: string;


  getPrimaryKey() {
    return this.id;
  }
}
